import PATH from "constants/path";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { SERVICE } from "constants/global";
import { getUser } from "features/User/userSlice";
import { Notice } from "components";
import { setCookie } from "utils/common";
import ErrorDB from "components/ErrorDB";

const Setting = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const handleLink = (path) => {
    history.push(path);
  };

  const { user, noticesInit, isInLine } = useSelector((state) => state.user);

  useEffect(() => {
    if (!user) {
      dispatch(getUser());
    }
  }, []);

  if (!user && !isInLine) return null;

  return (
    <div className="w-80 py-0 py-md-3">
      <Notice noticesInit={noticesInit} isInLine={isInLine}/>

      <div className="fs-20 fs-sm-18 fw-600 py-3 py-md-4 mb-1 text-center">
        会員設定
      </div>
      {
        isInLine ?
          <ErrorDB/>
          :
          <div className="row w-100 row-cols-1 row-cols-md-2 gx-0 gy-2 px-2 px-md-3 py-3 py-md-4 bg-grey">
            <div className="col mb-0 mb-md-3">
              <div className="mx-2 mx-md-3 px-3 py-2 py-md-3 d-flex justify-content-between align-items-center bg-white">
                <div className="fs-16 fs-sm-14 fw-600">会員情報</div>
                <div
                  onClick={() => handleLink(PATH.MEMBER_INFO)}
                  className="btn bg-red-light text-white w-btn-setting border-radius-5 fw-600 fs-14 fs-sm-12"
                >
                  確認・変更
                </div>
              </div>
            </div>
            <div className="col mb-0 mb-md-3">
              <div className="mx-2 mx-md-3 px-3 py-2 py-md-3 d-flex justify-content-between align-items-center bg-white">
                <div className="fs-16 fs-sm-14 fw-600">口座情報</div>
                <div
                  onClick={() => handleLink(PATH.ACCOUNT_INFO)}
                  className="btn bg-red-light text-white w-btn-setting border-radius-5 fw-600 fs-14 fs-sm-12"
                >
                  確認・変更
                </div>
              </div>
            </div>
            {/* <div className="col mb-0 mb-md-3">
              <div className="mx-2 mx-md-3 px-3 py-2 py-md-3 d-flex justify-content-between align-items-center bg-white">
                <div className="fs-16 fs-sm-14 fw-600">ログインID</div>
                <div
                  onClick={() => handleLink(PATH.CHANGE_LOGIN)}
                  className="btn bg-red-light text-white w-btn-setting border-radius-5 fw-600 fs-14 fs-sm-12"
                >
                  確認・変更
                </div>
              </div>
            </div> */}
            <div className="col mb-0 mb-md-3">
              <div className="mx-2 mx-md-3 px-3 py-2 py-md-3 d-flex justify-content-between align-items-center bg-white">
                <div className="fs-16 fs-sm-14 fw-600">メールアドレス</div>
                <div
                  onClick={() => handleLink(PATH.CHANGE_EMAIL)}
                  className="btn bg-red-light text-white w-btn-setting border-radius-5 fw-600 fs-14 fs-sm-12"
                >
                  確認・変更
                </div>
              </div>
            </div>
            <div className="col mb-0 mb-md-3">
              <div className="mx-2 mx-md-3 px-3 py-2 py-md-3 d-flex justify-content-between align-items-center bg-white">
                <div className="fs-16 fs-sm-14 fw-600">パスワード</div>
                <div
                  onClick={() => handleLink(PATH.PASSWORD)}
                  className="btn bg-red-light text-white w-btn-setting border-radius-5 fw-600 fs-14 fs-sm-12"
                >
                  確認・変更
                </div>
              </div>
            </div>

            <div className="col">
              <div className="mx-2 mx-md-3 px-3 py-2 py-md-3 d-flex justify-content-between align-items-center bg-white">
                <div className="fs-16 fs-sm-14 fw-600">メール配信設定</div>
                <div
                  onClick={() => {
                    window.location = `${PATH.COMMON}${PATH.UPDATE_MAIL.CHANGE}?service=${SERVICE}&url_back=${window.location.href}`;
                  }}
                  className="btn bg-red-light text-white w-btn-setting border-radius-5 fw-600 fs-14 fs-sm-12"
                >
                  設定・解除
                </div>
              </div>
            </div>

            <div className="col">
              <div className="mx-2 mx-md-3 px-3 py-2 py-md-3 d-flex justify-content-between align-items-center bg-white">
                <div className="fs-16 fs-sm-14 fw-600">退会</div>
                <div
                  onClick={() => {
                    window.location = `${PATH.COMMON}${PATH.WITHDRAWAL.CHECK}?service=${SERVICE}&url_back=${window.location.href}`;
                  }}
                  className="btn bg-white text-red-light border-color-red-light w-btn-setting border-radius-5 fw-600 fs-14 fs-sm-12"
                >
                  退会手続き
                </div>
              </div>
            </div>
          </div>
      }
    </div>
  );
};

export default Setting;
